<template>
  <div>
    <div class="chuang" v-if="ress">
      <div class="boxxx">
        <div class="card">
          <img
            @click="ej_close()"
            class="close"
            src="../../../assets/img/pagess/sky101/close (2).png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="h1">
      <div class="li-1">
        <div class="lis">关于我们</div>
      </div>
      <div class="li-2">
        股多多隶属于北京天相财富管理顾问有限公司，作为由证监会批准的证券投资咨询服务机构。多年来，<span>公司秉承金融科技为基、投研能力为本，</span>不断保持投研实力的专业性和产品创新的先发优势，打造出专注龙头股交易的智能决策炒股软件
        — 股多多
      </div>
    </div>
    <div class="h2">
      <div class="w">
        <div class="li-1">
          <img
            src="../../../assets/img/pagess/mobile/aboutUs/h2-1.png"
            alt=""
          />
        </div>
        <div class="li-2">
          <div class="lis" style="margin-bottom: 0.33rem; line-height: 0.4rem">
            <img
              src="../../../assets/img/pagess/mobile/aboutUs/h2-2.png"
              alt=""
            />
            <div class="text">
              证监会授权经营证券期货业务许可机构统一社会信用代码：91110102MA001GJE1N
            </div>
          </div>
          <div class="lis" style="margin-bottom: 0.47rem">
            <img
              src="../../../assets/img/pagess/mobile/aboutUs/h2-2.png"
              alt=""
            />
            <div class="text">沪、深交易所LEVEL-1交易数据服务商</div>
          </div>
          <div class="lis">
            <img
              src="../../../assets/img/pagess/mobile/aboutUs/h2-2.png"
              alt=""
            />
            <div class="text">中国版权保护中心颁发计算机软件著作证书</div>
          </div>
        </div>
        <div class="li-3">
          <wc-swiper @transitionend="fn">
            <wc-slide class="item">
              <img
                src="../../../assets/img/pagess/mobile/aboutUs/1-1.png"
                alt=""
              />
            </wc-slide>
            <wc-slide class="item">
              <img
                src="../../../assets/img/pagess/mobile/aboutUs/1-2.png"
                alt=""
              />
            </wc-slide>
            <wc-slide class="item">
              <img
                src="../../../assets/img/pagess/mobile/aboutUs/1-3.png"
                alt=""
              />
            </wc-slide>
            <wc-slide class="item">
              <img
                src="../../../assets/img/pagess/mobile/aboutUs/1-4.png"
                alt=""
              />
            </wc-slide>
          </wc-swiper>
        </div>
      </div>
    </div>
    <div class="h3">
      <div class="w">
        <div class="li-1">
          <img
            src="../../../assets/img/pagess/mobile/aboutUs/h3-1.png"
            alt=""
          />
        </div>
        <div class="li-2">
          <div class="lis1">
            <h3>擒龙环境</h3>
            <span>研判大盘趋势 知进退 懂取舍</span>
            <img
              src="../../../assets/img/pagess/mobile/aboutUs/1-1s.png"
              @click="open()"
              class="btn"
              alt=""
            />
          </div>
          <div class="lis2">
            <img
              src="../../../assets/img/pagess/mobile/aboutUs/h3-2.gif"
              alt=""
            />
          </div>
        </div>
        <div class="li-3">
          <div class="lis1">
            <h3>龙头雷达</h3>
            <div>
              <div class="text1">板块同屏 上班看盘两不误</div>
              <div class="text2">异动提示 实时监控盘中热点</div>
            </div>
            <img
              src="../../../assets/img/pagess/mobile/aboutUs/1-1s.png"
              @click="open()"
              class="btn"
              alt=""
            />
          </div>
          <div class="lis2">
            <img
              src="../../../assets/img/pagess/mobile/aboutUs/h3-3.gif"
              alt=""
            />
          </div>
        </div>
        <div class="li-4">
          <div class="lis1">
            <h3>龙头模型</h3>
            <div>
              <div class="text1">四大核心选股模型</div>
              <div class="text2">王牌指标硬核辅助</div>
            </div>
            <img
              src="../../../assets/img/pagess/mobile/aboutUs/1-1s.png"
              @click="open()"
              class="btn"
              alt=""
            />
          </div>
          <div class="lis2">
            <img
              src="../../../assets/img/pagess/mobile/aboutUs/h3-4.gif"
              alt=""
            />
          </div>
        </div>
        <div class="li-5">
          温馨提示：以上三个功能展示以产品最新迭代上线版本为准
        </div>
      </div>
    </div>
    <div class="h4">
      <div class="w">
        <div class="li-1">
          <img
            src="../../../assets/img/pagess/mobile/aboutUs/h4-1.png"
            alt=""
          />
        </div>
        <div class="li-2">
          股多多软件自面世以来，经过<span>多次深度</span>迭代更新，建立了一套成熟的寻龙体系，全自主开发<span>50+</span>特色智能操盘工具，<span>十大</span>量化选股策略；用多年的沉淀积累，立足长远珍惜历史性参与机会，股多多立志于和广大股民一起蜕变成长，以在共同富裕的过程中发挥更大作用。
        </div>
        <div class="li-3">
          <img
            src="../../../assets/img/pagess/mobile/aboutUs/h4-2.png"
            alt=""
          />
        </div>
        <div class="li-4">
          支撑起这一切的，是一支以金融行业高学历精英人才为核心班底，汇集<span>70</span>多位从业及资深投资顾问人员组成的金融投研团队。正是他们，才把龙头股分析做到厚重，成功由传统投顾选股转型为2.0选股模式——<span
            >智能AI选股模式</span
          >
        </div>
      </div>
    </div>
    <div class="h5">
      <div class="w">
        <div class="li-1">
          <img
            src="../../../assets/img/pagess/mobile/aboutUs/h5-1.png"
            alt=""
          />
        </div>
        <div class="li-2">
          公司坚持在国家法律与金融监管规则下，依法、合规开展经营活动。设置售后、客服、合规等部门，协助法律合规部对公司的合规体系及各项经营管理制度进行全面梳理；同步构建了完善的合规部门，团队成员均具备丰富的合规实践经验，自主搭建一系列合规系统，完善业务全链的合规性。
        </div>
        <div class="li-3">
          <img
            src="../../../assets/img/pagess/mobile/aboutUs/h5-3.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="h6">
      <div class="li-1">
        <img src="../../../assets/img/pagess/mobile/aboutUs/h6-1.png" alt="" />
      </div>
      <div class="li-2">
        <div class="img">
          <video
            controls="controls"
            poster="../../../assets/img/pagess/mobile/aboutUs/h6-3.png"
            src="https://mediadatabucket.oss-cn-shanghai.aliyuncs.com/RJ01/2022-04-29_%E5%80%AA%E7%AC%91%E5%A4%A9-%E8%82%A1%E5%A4%9A%E5%A4%9A%E5%9B%9B%E5%A4%A7%E7%89%B9%E6%9D%83%E6%8C%87%E6%A0%87%E8%AE%B2%E8%A7%A3.mp4"
          ></video>
        </div>
      </div>
    </div>
    <div class="h11" id="qr">
      <div class="li-1">
        <div class="lis"></div>
      </div>
      <div class="h7">
        <div>投资有风险，入市需谨慎！</div>
        <div>业务资格许可证编号：91110102MA001GJE1N</div>
        <div>
          使用天相财富提供的服务之前，请完整阅读我们的风险披露及条款声明
          天相财富是中国证监会批准设立的证券投资咨询机构
        </div>

        <div>开发者名称:北京天相财富管理顾问有限公司</div>

       <div>
        股多多软件版本号：v1.8.1.2 更新时间：2023/09/13 隐私保护政策
         软件服务协议
       </div>
      </div>
    </div>

    <div class="h8">
      <div>
        Copyright © 2020-2022 天相财富版权所有 北京天相财富管理顾问有限公司
      </div>
      <div>
        <a href="https://beian.miit.gov.cn/#/Integrated/index"
          ><img
            src="../../../assets/img/pagess/mobile/aboutUs/police.png"
            alt=""
          />京ICP备16068579号-8</a
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ress: true
    };
  },
  mounted() {},
  methods: {
    ej_close() {
      this.ress = false;
      window.location.href = "#qr";
    },
    open() {
      this.ress = true;
    },
    fn(e) {}
  }
};
</script>
<style lang="less" scoped>
.chuang {
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 9999;
  .boxxx {
    width: 100%;
    height: 100vh;
    background-color: rgba(7, 7, 7, 0.4);
    margin: 0px;
    padding: 0px;
    position: relative;
    .close {
      width: 0.3rem;
      height: 0.3rem;
      position: absolute;
      top: -0.3rem;
      right: -0.3rem;
    }
    .card {
      width: 5.62rem;
      height: 6.73rem;
      background: url(../../../assets/img/pagess/mobile/aboutUs/1-4s.png);
      background-size: 100% 100%;
      position: absolute;
      left: 50%;
      top: 50%;
      margin-left: -2.81rem;
      margin-top: -3.36rem;
    }
  }
}
.h1 {
  font-size: 0.1rem;
  width: 7.5rem;
  height: 6.19rem;
  background: url(../../../assets/img/pagess/mobile/aboutUs/h1.png);
  background-size: 100% 100%;
  .li-1 {
    padding-top: 4.1rem;
    padding-left: 0.2rem;
    .lis {
      width: 2.07rem;
      height: 0.52rem;
      background: url(../../../assets/img/pagess/mobile/aboutUs/h1-1.png);
      background-size: 100% 100%;
      font-size: 0.33rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #030366;
      text-align: center;
      line-height: 0.52rem;
    }
  }
  .li-2 {
    margin: 0 auto;
    margin-top: 0.17rem;
    width: 7.1rem;
    font-size: 0.24rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 0.34rem;
    span {
      color: #ff4119;
    }
  }
}
.h2 {
  font-size: 0.1rem;
  width: 7.5rem;
  height: 11.04rem;
  background: url(../../../assets/img/pagess/mobile/aboutUs/h2.png);
  background-size: 100% 100%;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  font-size: 0.1rem;
  .w {
    width: 7.16rem;
    height: 10.54rem;
    background-color: #fff;
    border-radius: 0.2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    .li-1 {
      padding-top: 0.46rem;
      img {
        width: 4.86rem;
        height: 0.54rem;
      }
    }
    .li-2 {
      width: 6.18rem;
      font-size: 0.24rem;
      font-family: Microsoft YaHei;
      color: #474545;

      img {
        padding-top: 0.09rem;
        width: 0.09rem;
        height: 0.09rem;
        margin-right: 0.28rem;
      }
      .lis {
        width: 100%;
        display: flex;
        align-items: flex-start;
      }
    }
    .li-3 {
      width: 100%;
      height: 6.1rem;
      margin-top: 0.3rem;
      .item {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      img {
        width: 4.63rem;
        height: 6rem;
      }
    }
  }
}
.h3 {
  font-size: 0.1rem;
  width: 7.5rem;
  height: 17.24rem;
  background: url(../../../assets/img/pagess/mobile/aboutUs/h3.png);
  background-size: 100% 100%;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  .w {
    width: 7.16rem;
    height: 16.58rem;
    background-color: #fff;
    border-radius: 0.2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    .li-1 {
      padding-top: 0.45rem;
      img {
        width: 4.86rem;
        height: 0.6rem;
      }
    }
    .li-2 {
      margin-top: 0.54rem;
      .lis1 {
        display: flex;
        align-items: center;
        justify-content: space-between;
        img {
          width: 1.83rem;
          height: 0.5rem;
        }
        h3 {
          font-size: 0.4rem;
          font-weight: 600;
          color: #f03229;
          margin: 0;
        }
        span {
          margin-left: 0.35rem;
          font-size: 0.26rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #3f3f3f;
          line-height: 0.24rem;
        }
      }
      .lis2 {
        margin-top: 0.24rem;
        width: 6.95rem;
        height: 3.34rem;
        background-color: #d5e0f8;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 6.82rem;
          height: 3.17rem;
        }
      }
    }
    .li-3 {
      margin-top: 0.28rem;
      .lis1 {
        display: flex;
        align-items: center;
        justify-content: space-between;
        img {
          width: 1.83rem;
          height: 0.5rem;
        }
        h3 {
          font-size: 0.4rem;
          font-weight: 600;
          color: #f03229;
          margin: 0;
        }
        .text1 {
          margin-bottom: 0.05rem;
        }
        .text1,
        .text2 {
          margin-left: 0.35rem;
          font-size: 0.26rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #3f3f3f;
          line-height: 0.24rem;
        }
      }
      .lis2 {
        margin-top: 0.24rem;
        width: 6.95rem;
        height: 4.01rem;
        background-color: #d5e0f8;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 6.81rem;
          height: 3.77rem;
        }
      }
    }
    .li-4 {
      margin-top: 0.45rem;
      .lis1 {
        display: flex;
        align-items: center;
        padding-left: 0.34rem;
        justify-content: space-between;
        img {
          width: 1.83rem;
          height: 0.5rem;
        }
        h3 {
          font-size: 0.4rem;
          font-weight: 600;
          color: #f03229;
          margin: 0;
        }
        span {
          margin-left: 0.35rem;
          font-size: 0.26rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #3f3f3f;
          line-height: 0.24rem;
        }
      }
      .lis2 {
        margin-top: 0.24rem;
        width: 6.95rem;
        height: 4.01rem;
        background-color: #d5e0f8;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 6.79rem;
          height: 3.76rem;
        }
      }
    }
    .li-5 {
      font-size: 0.14rem;
      font-family: Microsoft YaHei;
      color: #b4b3b3;
      margin-top: 0.1rem;
    }
  }
}
.h4 {
  font-size: 0.1rem;
  width: 7.5rem;
  height: 9.45rem;
  background: url(../../../assets/img/pagess/mobile/aboutUs/h4.png);
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  .w {
    width: 7.16rem;
    height: 8.99rem;
    background-color: #fff;
    border-radius: 0.2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    .li-1 {
      padding-top: 0.48rem;
      margin-bottom: 0.29rem;
      img {
        width: 5.9rem;
        height: 0.59rem;
      }
    }
    .li-2 {
      width: 6.2rem;
      font-size: 0.26rem;
      font-family: Microsoft YaHei;
      color: #333333;
      span {
        color: #ff0000;
        font-weight: 600;
      }
    }
    .li-3 {
      margin-top: 0.43rem;
      img {
        width: 6.54rem;
        height: 3.21rem;
      }
    }
    .li-4 {
      width: 6.5rem;
      font-size: 0.26rem;
      font-family: Microsoft YaHei;
      color: #333333;
      line-height: 0.34rem;
      span {
        color: #ff0000;
        font-weight: 600;
      }
    }
  }
}
.h5 {
  font-size: 0.1rem;
  width: 7.5rem;
  height: 9.32rem;
  background: url(../../../assets/img/pagess/mobile/aboutUs/h5.png);
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  .w {
    width: 7.16rem;
    height: 8.96rem;
    background-color: #fff;
    border-radius: 0.2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    .li-1 {
      padding-top: 0.45rem;
      img {
        width: 4.86rem;
        height: 0.55rem;
      }
    }
    .li-2 {
      margin-top: 0.37rem;
      width: 6.37rem;
      font-size: 0.26rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      line-height: 0.37rem;
    }
    .li-3 {
      width: 6.3rem;
      height: 5.02rem;
      background: url(../../../assets/img/pagess/mobile/aboutUs/h5-2.png);
      background-size: 100% 100%;
      margin-top: 0.12rem;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 5.8rem;
        height: 3.98rem;
      }
    }
  }
}
.h6 {
  width: 7.5rem;
  height: 8.1rem;
  background: url(../../../assets/img/pagess/mobile/aboutUs/h6.jpg);
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .li-1 {
    padding-top: 1.23rem;
    img {
      width: 5.13rem;
      height: 1.2rem;
    }
  }
  .li-2 {
    margin-top: 0.12rem;
    width: 7.16rem;
    height: 4.7rem;
    background: url(../../../assets/img/pagess/mobile/aboutUs/h6-2.png);
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    .img {
      padding-top: 0.89rem;
    }
    video {
      width: 6.88rem;
      height: 3.54rem;
    }
  }
}
.h7 {
  text-align: center;
  width: 100%;
  font-size: 0.16rem;
  color: #9e9e9e;
  display: flex;
  flex-direction: column;
  align-items: center;
  div {
    margin-bottom: 0.02rem;
  }
}
.h8 {
  text-align: center;
  width: 100%;
  font-size: 0.16rem;
  color: #9e9e9e;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #21209f;
}
.h11 {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 7.5rem;
  background: url(../../../assets/img/pagess/mobile/aboutUs/1-2s.png);
  background-size: 100% 100%;

  .li-1 {
    padding-top: 2rem;
    .lis {
      margin: 0 auto;
      top: 2rem;
      left: 0.3rem;
      width: 6.92rem;
      height: 2.82rem;
      background: url(../../../assets/img/pagess/mobile/aboutUs/1-3s.png);
      background-size: 100% 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/pagess/mobile/aboutUs_mobile.vue